import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { doGetPromise, doDeletePromise } from '../../../../config/core.httpclient-utils';

@Injectable()
export class MyReportsRest {
  constructor(private http: HttpClient) {}

  save(id: number | string, details: any): Promise<any> {
    return this.http.post(`/api/myreport/${id}/details`, details).toPromise();
  }

  fetch(params: any = {}): Promise<any> {
    return doGetPromise(this.http, '/api/myreport', params);
  }

  getDetails(id: number | string): Promise<any> {
    return doGetPromise(this.http, `/api/myreport/${id}/details`);
  }

  getData(id: number | string, params: any): Promise<any> {
    return doGetPromise(this.http, `/api/myreport/${id}/data`, params);
  }

  getProjects(): Promise<any> {
    return doGetPromise(this.http, '/api/myreport/0/projects');
  }

  getFilters(params): Promise<any> {
    return doGetPromise(this.http, '/api/myreport/0/filters', params);
  }

  delete(id: number | string): Promise<any> {
    return this.http.delete(`/api/myreport/${id}`).toPromise();
  }
}
